import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { renderWithBold } from "../lib/markdown";

export const AboutUs = () => {
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    api
      .get("/about")
      .then((res) => {
        if (mounted) setBody(res.data.body || "");
      })
      .catch(() => {})
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  const paragraphs = body
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <section
      id="about"
      className="w-full py-16 md:py-24 px-6"
      style={{ backgroundColor: "var(--bg-secondary)" }}
      data-testid="about-section"
    >
      <div className="max-w-3xl mx-auto text-center">
        <p
          className="font-script text-3xl md:text-4xl mb-3"
          style={{ color: "var(--text-accent)" }}
        >
          Hello, friend
        </p>
        <h2
          className="font-display text-4xl md:text-5xl lg:text-6xl mb-8 leading-tight"
          style={{ color: "var(--text-primary)" }}
        >
          About Us
        </h2>

        <div className="flex items-center justify-center gap-3 mb-10">
          <span
            className="h-px w-12"
            style={{ backgroundColor: "var(--border-soft)" }}
          />
          <span
            className="font-script text-xl"
            style={{ color: "var(--brand-rose)" }}
          >
            ♥
          </span>
          <span
            className="h-px w-12"
            style={{ backgroundColor: "var(--border-soft)" }}
          />
        </div>

        {loading ? (
          <p
            className="font-script text-xl"
            style={{ color: "var(--text-secondary)" }}
          >
            loading…
          </p>
        ) : (
          <div className="space-y-5 md:space-y-6" data-testid="about-body">
            {paragraphs.map((p, idx) => (
              <p
                key={idx}
                className="text-base md:text-lg leading-[1.8] tracking-[0.005em]"
                style={{ color: "var(--text-secondary)" }}
              >
                {renderWithBold(p, {
                  fontFamily: "'Caveat', cursive",
                  fontWeight: 600,
                  fontSize: "1.35em",
                  lineHeight: 1,
                  color: "var(--brand-sage)",
                  letterSpacing: "0.01em",
                })}
              </p>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default AboutUs;
